import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'

// Deploy trocou os arquivos com a aba aberta (chunk antigo sumiu): em vez de tela
// branca, recarrega a página uma vez. Trava de 30s evita loop se o erro persistir.
window.addEventListener('vite:preloadError', (evento) => {
  const ultimo = Number(sessionStorage.getItem('recarga-pos-deploy') || 0);
  if (Date.now() - ultimo > 30000) {
    sessionStorage.setItem('recarga-pos-deploy', String(Date.now()));
    evento.preventDefault();
    window.location.reload();
  }
});


ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
